import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useKSK1090_R01Store } from "./Store_KSK1090_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_KSK1090_R01 } from "./Content_KSK1090_R01";
import { SearchSection_KSK1090_R01 } from "./SearchSection_KSK1090_R01";
import { Table_KSK1090_R01 } from "./Table_KSK1090_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { GridRowData } from "./Dto_KSK1090_R01";

export const Container_KSK1090_R01 = () => {
    const { initData } = useKSK1090_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<GridRowData>>(null);

    const {
        fetchData,
        handleExcelClick,
    } = Content_KSK1090_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            <SearchSection_KSK1090_R01 />
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    <Table_KSK1090_R01 gridRef={gridRef} />
                </div>
            </div>
        </div>
    );
};


